import React, { useState, useContext, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../Routes/paths";
import { ChartLegend } from "../../../Components/Atoms";
import { ModelPicker } from "../../../Components/Molecules";
import { Stack } from "../../../Components/Organisms/Graphs";
import { Report } from "../../../Templates";
import { getStatsData, getVehicleStats, getWidgetData } from "../../../APIs";
import { StoreContext } from "../../../Library/contexts";
import { DATE_RANGES } from "../../../Library/constants";
import { MODULE_TYPES, processReportData } from "../../../Library/widgets";
import { getUserAndVehicle } from "../../../Library/helpers";
const labelData = ["0-25%", "25-50%", "50-75%", "75-100%"];
const parser = { x: "model", y: "count", xLabel: "Vehicles Count", yLabel: "Battery Health %" };
const paths = [
  { idx: 0, name: "Analytics", link: PATHS.ANALYTICS },
  { idx: 1, name: "Battery Health", isCurrentPage: true },
];
const processData = (data, constants) => {
  // For Grouping Counts >= 5
  const graphs = [];
  const legends = [];
  data.forEach((d) => {
    let counts = d.count.map(({ count }) => count);
    graphs.push({
      color: constants.modelMap[d.model].color,
      model: constants.modelMap[d.model].nm,
      count: counts,
      modelId: d.model,
    });
    legends.push({ label: constants.modelMap[d.model].nm, color: constants.modelMap[d.model].color, modelId: d.model });
  });
  return { graphs, legends };
};
const Health = () => {
  const navigate = useNavigate();
  const { filters } = useContext(StoreContext);
  const reportRef = useRef(null);
  const widgetData = useRef(null);
  const reportData = useRef({});
  const tableData = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const handleFetchData = useCallback(async (filters, constants) => {
    setIsLoading(true);
    let categories = [];
    if (!widgetData.current) {
      // Used to Fetch Switcher Options
      const widgetResp = await getWidgetData(DATE_RANGES[filters.range], [MODULE_TYPES.BATTERY_HEALTH]);
      if (!widgetResp) return;
      categories = widgetResp[0].data;
      widgetData.current = categories;
      reportData.current = {};
      tableData.current = null;
      const response = await getStatsData(DATE_RANGES[filters.range], MODULE_TYPES.BATTERY_HEALTH);
      const grouped = processReportData(response, "dst");   // Grouped Model-wise
      reportData.current = processData(grouped, constants);
    }
    if (!tableData.current) {
      const response = await getVehicleStats(DATE_RANGES[filters.range], MODULE_TYPES.BATTERY_HEALTH);
      tableData.current = getUserAndVehicle(response);
    }
    setIsLoading(false);
  }, []);
  useEffect(() => {
    if (reportRef.current) reportRef.current.apply();
  }, [handleFetchData]);
  const getFilteredData = (data) => {
    const modelSet = new Set(filters.models);
    return data.filter((d) => modelSet.has(d.modelId));
  };
  
  const getFilteredLegend = (data) => {
    const modelSet = new Set(filters.models);
    return data.filter((d) => modelSet.has(d.modelId));
  };
  const handleClick = (row, col) => {
    if (col == undefined) return;

    const newPaths = [...paths];
    newPaths[paths.length - 1] = {
      ...newPaths[paths.length - 1],
      link: PATHS.ANALYTICS + "/" + PATHS.BATTERY_HEALTH,
      isCurrentPage: false,
    };
    newPaths.push({ idx: 2, name: "Data", isCurrentPage: true });
    const graphData = getFilteredData(reportData.current.graphs);
    const state = {
      model: graphData[col].modelId,
      fault: MODULE_TYPES.BATTERY_HEALTH,
      title: "Battery Health - Data",
      paths: newPaths,
    };
    navigate(PATHS.REPORTS, { state });
  };
  return (
    <Report breadcrumb={paths} title={"Battery Health"} isLoading={isLoading} onApply={handleFetchData} ref={reportRef}>
      {!isLoading && (
        <>
          <div className="panel-chart-header">
            <ChartLegend data={getFilteredLegend(reportData.current.legends)} />
            <ModelPicker />
          </div>
          <div className="panel-chart-main">
            <label className="panel-chart-label">
              Battery Health %, All Vehicles
            </label>
            <Stack data={getFilteredData(reportData.current.graphs)} labels={labelData} parser={parser} title="Battery Health" onClick={handleClick} />
          </div>
          <div className="panel-chart-sheet">
          </div>
        </>
      )}
    </Report>
  );
}
export default Health;